// extracted by mini-css-extract-plugin
export var border = "_r-7";
export var brand = "_r-s";
export var button = "_r-k";
export var center = "_r-9";
export var centered = "_r-5";
export var closeButton = "_r-b";
export var disabledWrapper = "_r-l";
export var error = "_r-o";
export var extraLarge = "_r-4";
export var extraSmall = "_r-1";
export var fill = "_r-h";
export var footer = "_r-g";
export var footerAction = "_r-i";
export var footerButtons = "_r-j";
export var header = "_r-6";
export var headerWithClose = "_r-c";
export var icon = "_r-n";
export var info = "_r-r";
export var inline = "_r-8";
export var large = "_r-3";
export var main = "_r-d";
export var modal = "_r-0";
export var neutral = "_r-t";
export var noPadding = "_r-f";
export var none = "_r-u";
export var scrollable = "_r-e";
export var small = "_r-2";
export var success = "_r-q";
export var tight = "_r-m";
export var titleIcon = "_r-a";
export var warn = "_r-p";